GP.collections.Activities = Backbone.Collection.extend({
    model:GP.models.Activity,
    comparator: function(activity) {
        return -activity.get('ctime');
    }
});
